import { render, staticRenderFns } from "./CountdownBtn.vue?vue&type=template&id=205646ce&scoped=true&lang=pug"
import script from "./CountdownBtn.vue?vue&type=script&lang=js"
export * from "./CountdownBtn.vue?vue&type=script&lang=js"
import style0 from "./CountdownBtn.vue?vue&type=style&index=0&id=205646ce&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205646ce",
  null
  
)

export default component.exports